import React, { useContext } from 'react';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import SubHeader, {
	SubHeaderLeft,
	SubheaderSeparator,
} from '../../../layout/SubHeader/SubHeader';
import Page from '../../../layout/Page/Page';
import AuthContext from '../../../contexts/authContext';
import { demoPagesMenu } from '../../../menu';
import TodayFeeCollection from './dashboard-component/TodayFeeCollection';
import FeesCollection from './dashboard-component/FeesCollection';
import AttendanceNotSubmitted from './dashboard-component/AttendanceNotSubmitted';
import PendingFees from './dashboard-component/PendingFees';
import TodayAbsentCount from './dashboard-component/TodayAbsentCount';
import StaffActivity from './dashboard-component/StaffActivity';
import StudentFeeTransaction from './dashboard-component/StudentFeeTransaction';
import Circular from '../../../components/management/circular-details/Circular';
import ComplaintList from '../../../components/management/complaint/ComplaintList';
import DepartmentWiseAttendanceSummary from './dashboard-component/DepartmentWiseAttendanceSummary';

const AdminDashboard = () => {
	const { userData } = useContext(AuthContext);

	return (
		<PageWrapper title={demoPagesMenu.sales.subMenu.dashboard.text}>
			<SubHeader>
				<SubHeaderLeft>
					<span className='fs-5'>Today Overview </span>
					<SubheaderSeparator />
					<strong className='fs-5'>Hi, <span className='text-primary'>{`${userData.fullname}`}</span> !</strong>
				</SubHeaderLeft>
			</SubHeader>
			<Page container='fluid'>
				<div className='row'>
					<div className='col-xl-6'>
						<TodayFeeCollection />
					</div>
					<div className='col-xl-6'>
						<TodayAbsentCount />
					</div>
					<div className='col-xl-8'>
						<DepartmentWiseAttendanceSummary />
					</div>
					<div className='col-xl-4'>
						<StaffActivity />
					</div>
					<div className='col-xl-6'>
						<StudentFeeTransaction />
					</div>
					<div className='col-xl-6'>
						<FeesCollection />
					</div>
					<div className='col-xl-6'>
						<PendingFees />
					</div>
					<div className='col-xl-6'>
						<AttendanceNotSubmitted />
					</div>
					<div className='col-xl-6'>
						<Circular />
					</div>
					<div className='col-xl-6'>
						<ComplaintList type={'dashboard'} />
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default AdminDashboard;
